import React, { useEffect } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import Reactplayer from "./ReactPlayer";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const About = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="bg-[#fff]">
      <Nav active="about" />
      <div className="border-8 border-red-600">
        <div className="max-w-[1320px] md:mx-auto mx-4 flex justify-center  md:justify-between flex-wrap mt-12">
          <div className="flex-grow mx-auto max-w-[600px]">
            <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
              To video creators who aren't expert editors
            </h1>
            <p className="mt-4 text-2xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              Find out how to create quality and on-brand videos consistently,
              without editing them yourself.
            </p>
            <div className="mt-4 mb-10 text-center md:mt-8 lg:text-left">
              <button className="px-4 p-3 m-1 mt-2 mr-[1px] md:text-xl text-lg font-semibold bg-[#508dff] rounded-md transition duration-200 ease-out text-[#fff] hover:shadow-2xl">
                Get started
              </button>
            </div>
            <p className="mt-4 mb-6 text-lg  text-[#4f4f4f]  text-center lg:text-left">
              Action based money back guarantee
            </p>
          </div>

          <div className="flex-grow sm:min-w-[450px] min-w-[290px]  max-w-[591px] mx-auto  px-2 sm:px-4 mt-4">
            <Reactplayer url="https://www.youtube.com/watch?v=vNx2Z7ePCoM&t=4s" />
          </div>
        </div>
        <img
          src={require("../images/mountain.png")}
          alt=""
          className="w-[100vw] h-80 hidden lg:block"
        />
        <div className="bg-white md:-mt-16">
          <div className="flex-grow md:mx-auto max-w-[730px] py-16 mx-4">
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f] opacity-90 text-center lg:text-left">
              Imagine if you never had to do your own video editing.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f] opacity-90 text-center lg:text-left">
              Being able to let go of that boring task you feel forced to do,
              and finally get back to what you want to do.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              You could outsource your editing to a freelance editor or a new
              employee.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              But the idea of going through all the searching, negotiating,
              hiring, and training to bring on the right editor, turns into a
              heavy black cloud of 'more work'.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              And even if you did decide to go through all of that, you might
              find yourself having to always chase up your editor in an awkward
              back-and-forth.
            </p>
            <p className="mt-4 text-xl leading-9  text-[#4f4f4f]  text-center lg:text-left font-semibold">
              Shouldn't there be a way to just get your editing done quickly and
              reliably, without all of this extra legwork?
            </p>

            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              I think so - that's why I created Video Husky.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              Video Husky started with me, Justin, and one skilled editor.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              In 2018 I was running Facebook ads for my clients, and video was
              becoming increasingly popular.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              So I started creating videos, but didn't really know what I was
              doing.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              When I took on more clients, the demand was increasing and I
              couldn't keep up because I was spending all my time editing
              videos, instead of running my agency.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              The only way to meet this demand and hit my deadlines, was to
              spend a ton of time and money to try and find a reliable editor.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              And because I didn't know what to look for in an editor, it was
              nearly impossible to find the right one.
            </p>
            <p className="mt-4 text-xl leading-9  text-[#4f4f4f]  text-center lg:text-left font-semibold">
              I was stuck with a huge pile of videos to edit, without any way to
              get them out.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              This is the moment when I came up with a video editing system that
              takes care of everything video editing related - quickly and
              reliably.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              I hired a friend to be my editor and he worked on the videos,
              while I managed the projects and communicated with our clients.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              Our goal was simplicity. We would do as many revisions as they
              needed, and we wouldn't limit how many videos we'd do for them in
              a month. All on a flat fee.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              All the client needed to do was send us the footage and editing
              instructions, and we'd take it from there.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              They were able to turn their video creation process into an
              efficient production line and they got out more videos, more
              consistently, with less work than ever before.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              And their video quality improved because they had more time to
              work on the creatives.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              But more importantly, they knew they could rely on us to help them
              hit their deadlines, without having to look over our shoulders.
            </p>
            <p className="mt-4 text-xl leading-9  text-[#4f4f4f]  text-center lg:text-left font-semibold">
              And that's how we started Video Husky.
            </p>
            <p className="mt-4 text-xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
              Now we have an awesome team of editors, account managers, customer
              success agents, and me!
            </p>
          </div>
        </div>
        <div className="bg-[#fff]">
          <div className="w-full pt-24 pb-20 px-[20px] md:px-2  max-w-[1320px] mx-auto flex  flex-wrap justify-center xl:justify-between">
            <div className="flex-grow xl:max-w-[500px]  max-w-[700px]">
              <h1 className="md:text-[43px] text-[30px] text-center xl:text-left font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
                Join all the video creators who no longer have to do their video
                editing
              </h1>
              <div className="mt-4 mb-10 text-center md:mt-8 lg:text-left">
                <button className="px-4 p-3 m-1 mt-2 mr-[1px] md:text-xl text-lg font-semibold bg-[#508dff] transition duration-200 ease-out text-[#fff] rounded-md hover:shadow-2xl">
                  Get your videos edited
                </button>
              </div>
              <p className="mt-4 mb-6 text-lg  text-[#4f4f4f]  text-center lg:text-left">
                Action based money back guarantee
              </p>
            </div>
            <div className="flex-grow max-w-[750px] ">
              <p className="mt-4 text-xl leading-9 text-[#52626f]  text-center xl:text-left">
                After just 2 years, we now work with over 100 people like you
                who've gotten their lives back, after finally being able to
                outsource their editing.
              </p>
              <p className="mt-7 text-xl leading-9 text-[#52626f]  text-center xl:text-left">
                That's pretty awesome, but what really blows me away is the
                quality of the people who've joined us.
              </p>
              <p className="mt-7 text-xl leading-9 text-[#52626f]  text-center xl:text-left">
                From real estate agents, to YouTube creators, and even niche
                eCommerce businesses... They're people from different kinds of
                backgrounds who all believe the same thing:
              </p>
              <p className="mt-4 text-xl leading-9  text-[#4e5961]  text-center lg:text-left font-semibold">
                Creators shouldn't be wasting their valuable time editing their
                videos.
              </p>
              <p className="mt-7 text-xl leading-9 text-[#52626f]  text-center xl:text-left">
                And we all want you to stop wasting your time editing too!
              </p>
              <p className="mt-7 text-xl leading-9 text-[#52626f]  text-center xl:text-left">
                So you can take more opportunities, be more successful with your
                business, and have more time for fun!
              </p>
              <p className="mt-7 text-xl leading-9 text-[#52626f]  text-center xl:text-left">
                Join Video Husky and get your life back today.
              </p>
            </div>
            <div className="max-w-[1290px] pt-16 overflow-x-scroll scrollbar-hide px-4 md:mx-auto mx-3">
              <img
                src={require("../images/brandList.png")}
                alt=""
                className="h-20 mx-auto opacity-50 min-w-[880px]"
              />
            </div>
          </div>
        </div>
        <div className="bg-white pb-28">
          <div
            // data-aos="fade-up"
            // data-aos-delay="200"
            // data-aos-duration="1000"
            className=" max-w-[1000px] mx-auto px-5 pt-16 pb-28"
          >
            <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              What we stand for
            </h1>
            <p className="mt-5 md:text-[23px] max-w-[880px] mx-auto text-[18px] leading-9 text-[#52626f]  text-center ">
              {`We share 4 core values that guide everything we do:`}
            </p>
          </div>
          <div className="max-w-[1320px] mx-auto px-4 flex justify-around xl:justify-between flex-wrap">
            <div className=" max-w-[520px] my-6">
              <p className="mt-4 text-xl leading-9   text-[#353b40]  text-center  font-semibold">
                WORKING HONESTLY
              </p>
              <p className="mt-4 text-xl leading-[30px] text-[#505a62e6]  text-center ">
                We believe in being 100% honest and transparent with you...
                We'll work hard to ensure your videos are edited efficiently,
                but we'll never make promises that we can't deliver on, because
                your trust means more to us than earning another dollar.
              </p>
            </div>
            <div className=" max-w-[520px] my-6">
              <p className="mt-4 text-xl leading-9   text-[#353b40]  text-center  font-semibold">
                BEING PROACTIVE
              </p>
              <p className="mt-4 text-xl leading-[30px] text-[#505a62e6]  text-center ">
                You're a busy person, so we want this to be as hands-off for you
                as possible... That's why we use our initiative to make sure
                your videos get done right, without you feeling like you have to
                look over our shoulders.
              </p>
            </div>
            <div className=" max-w-[520px] my-6">
              <p className="mt-4 text-xl leading-9   text-[#353b40]  text-center  font-semibold">
                ALWAYS STRIVING FOR BETTER
              </p>
              <p className="mt-4 text-xl leading-[30px] text-[#505a62e6]  text-center ">
                Video is art, and great art requires high standards. The
                standards you set with every video editing request. We aim to go
                beyond. Sometimes we might not get there the first time around,
                but you can count on us to work on it until you're completely
                satisfied.
              </p>
            </div>
            <div className=" max-w-[520px] my-6">
              <p className="mt-4 text-xl leading-9   text-[#353b40]  text-center  font-semibold">
                BEING PROFESSIONAL
              </p>
              <p className="mt-4 text-xl leading-[30px] text-[#505a62e6]  text-center ">
                Your investment deserves our utmost respect and attention, and
                that's exactly what you'll get at Video Husky. You can trust us
                to always be reliable, available to help, and most of all
                positive, so you enjoy your experience with us!
              </p>
            </div>
          </div>
        </div>

        <div className="bg-[#fff] pt-10">
          <div
            // data-aos="fade-up"
            // data-aos-delay="200"
            // data-aos-duration="1000"
            className=" max-w-[1000px] mx-auto px-5 pt-24 pb-20"
          >
            <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              Join hundreds of other video creators who no longer have to edit
              their own videos
            </h1>
          </div>
          <div className="pb-10 -mt-12 text-center ">
            <Link to="/how-it-works">
              <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#508dff] transition duration-200 ease-out text-[#fff] rounded-md text-center mx-auto">
                Get your videos edited
              </button>
            </Link>
            <p className="mt-4 mb-6 text-lg  text-[#4f4f4f]  text-center ">
              Action based money back guarantee
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;

// font-family: "Avenir Next","Helvetica Neue","HelveticaNeue",Helvetica,Arial,sans-serif;
